import { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import config from '../../config';
import './index.css';


function SideBar({activeIndex}) {
  const account = useSelector((state) => state.account.account);

  const navigation = useNavigate();
  const [open, setOpen] = useState(false);

  const genLinkAndActiveIndex = (id) => {
    switch (id) {
      case config.menu_id.dashboard: {
        return {
          link: '/',
          activeIndex: 1
        }
      }
      case config.menu_id.user: {
        return {
          link: '/manage_user',
          activeIndex: 2
        }
      }
      case config.menu_id.storage: {
        return {
          link: '/manage_storage',
          activeIndex: 3
        }
      }
    }
  }
 
  return (
    <>
      <div className="side-bar-wrap" onMouseLeave={()=>{setOpen(false)}}>
        <div className="name-side-bar">
            <img className="logo_text" src="./dashboard/logo_text.png" alt="" />
            <img className="logo_icon" src="./dashboard/logo_icon.png" alt="" />
        </div>
        <div className="nav-sidebar">
            <div className="side-bar">
                <ul>
                    {account.menu.map((item, index) => {
                      const temp = genLinkAndActiveIndex(item.permission._id);
                      return (
                        <li key={index}>
                          <Link 
                          className={activeIndex !== temp.activeIndex ? "text-decoration-none" : "active text-decoration-none"} 
                          to={temp.link}
                          >
                            <img className='img_dashboard' src={activeIndex === temp.activeIndex ? item.permission.icon_active : item.permission.icon} alt=""/> 
                            <p>{item.permission.content}</p>
                          </Link>
                        </li>
                      )
                    })}
                    {/* <li>
                    <Link 
                        className={activeIndex !== 1 ? "text-decoration-none" : "active text-decoration-none"} 
                        to='/'
                    >
                        <img className='img_dashboard' src={activeIndex == 1 ? "./dashboard/space_dashboard_white.png":"./dashboard/space_dashboard.png"} alt=""/> 
                        <p>Dashboard</p>
                    </Link> 
                    </li>
                    <li>
                    <div
                      onClick={() => {setOpen(!open)}}
                      onMouseEnter={()=>{setTimeout(()=>{setOpen(true)},500)}}
                      aria-expanded={open}
                      className={activeIndex !==2 ? "sidebar_2_button_collapse" : "sidebar_2_button_collapse active"}
                    >
                      <img className='img_dashboard' src={activeIndex != 2 ? "./dashboard/account_box.png":"./dashboard/account_box_white.png"} alt="" /> 
                      <p>Người dùng</p>
                    </div>
                    <Collapse in={open}>
                      <div className="collapse_link">
                        <Link className='active' to='/manage_user'>Quản lý người dùng</Link>
                        <Link to=''>Báo cáo người dùng</Link>
                      </div>
                    </Collapse> 
                    </li>
                    <li>
                    <Link
                        className={activeIndex !== 3 ? "text-decoration-none" : "active text-decoration-none"} 
                        to='/manage_storage'
                    >
                        <img className='img_dashboard' src={activeIndex == 3 ? "./dashboard/database_white.png":"./dashboard/database.png"} alt=""/> 
                        <p>Storage</p>
                    </Link> 
                    </li> */}
                    
                </ul>
            </div>
        </div>
      </div>
      {/* <div 
          variant='link'
          className="text-decoration-none logout"
          onClick={() => {
          setShowLogoutPopup(true);
          }}
      >
          <img className='icon_logout' src="./dashboard/icon_logout.png" alt="" />
          <p>Đăng xuất</p>
      </div> */}
      {/* <ModalNoti 
      show={showLogoutPopup}
      onHide={hidePopup}
      closeButton={false}
      content={'Bạn muốn thoát khỏi hệ thống?'}
      leftButton={{
        onClick: () => {
          hidePopup();
        },
        content: 'Đóng'
      }}
      rightButton={{
        onClick: () => {
          dispatch(logout());
        },
        content: 'Đồng ý'
      }}
    ></ModalNoti> */}
    </>
    
  );
}

export default SideBar;